module.exports = __webpack_public_path__ + "img/hr-tree-01-j-trunk.13127e43.png";